import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { HistoricoEstoque } from 'src/app/models/historico-estoque';
import { Produto } from 'src/app/models/produto';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { ProdutoService } from 'src/app/services/produto.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';

@Component({
  selector: 'app-historico-estoque-modal',
  templateUrl: './historico-estoque-modal.component.html',
  styleUrls: ['./historico-estoque-modal.component.scss']
})
export class HistoricoEstoqueModalComponent implements OnInit, OnDestroy {

  // variáveis  
  historico: HistoricoEstoque[] = [];
  
  produto: Produto = new Produto();
  
  titulo = 'Histórico do Estoque';

  mostrarCodErp = false;
  
  idFornecedor;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(public utilitarioService: UtilitarioService, private premissasService: PremissasService,
    private globalService: GlobalService,
    private router: Router, private carregandoService: CarregandoService, private notificacaoService: NotificacaoService, private produtoService: ProdutoService,
    public dialogRef: MatDialogRef<HistoricoEstoqueModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  async ngOnInit() {
    
    this.buscarMostrarCodErp();
    
    this.produto = this.data.produto;    
    this.idFornecedor = this.data.idFornecedor;

    this.buscarHistorico();
  }

  buscarHistorico() {
    this.carregandoService.mostra('buscarPedidos');

    this.produtoService.consultarHistoricoDoEstoque(this.produto.idProduto, this.idFornecedor).subscribe(dados => {
      this.historico = dados;      
      this.carregandoService.esconde('buscarPedidos');
    }, (erro) => {
      this.carregandoService.esconde('buscarPedidos');
      this.notificacaoService.erro(erro);
    });
  }

  
  fechar() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {

  }

  buscarMostrarCodErp() {
    this.carregandoService.mostra('buscarMostrarCodErp');
    this.premissasService.consultarMostrarCodErp().subscribe(f => {
      this.mostrarCodErp = f.valor;
      this.carregandoService.esconde('buscarMostrarCodErp');
    }, (erro) => {
      this.carregandoService.esconde('buscarMostrarCodErp');
      this.notificacaoService.erro(erro);
    });
  }  
}
